// import React, { useState } from "react";
// import { supabase } from "../lib/supabaseclient"; // ✅ make sure path is correct

// export default function Contact() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Insert into Supabase
//     const { error } = await supabase.from("contact_requests").insert([
//       {
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         message: formData.message,
//       },
//     ]);

//     setLoading(false);

//     if (error) {
//       console.error("❌ Error submitting form:", error.message);
//       alert("Something went wrong. Please try again.");
//     } else {
//       console.log("✅ Form submitted successfully!");
//       setShowPopup(true);
//       setFormData({ name: "", email: "", phone: "", message: "" });

//       // Auto-hide popup after 3 sec
//       setTimeout(() => setShowPopup(false), 3000);
//     }
//   };

//   return (
//     <section className="bg-[#f8faff] py-16">
//       <div className="max-w-6xl mx-auto px-6">
//         {/* Header */}
//         <section className="relative bg-[linear-gradient(160deg,#1e40af_0%,#0891b2_100%)] text-white py-20">
//           <div className="container mx-auto px-6 text-center">
//             <h1 className="text-4xl sm:text-5xl font-extrabold mb-4">
//               Contact Us
//             </h1>
//             <p className="text-blue-100 max-w-2xl mx-auto text-lg">
//               We’d love to hear from you! Get in touch with our team for support,
//               inquiries, or partnership opportunities.
//             </p>
//           </div>
//         </section>


//         <div className="grid md:grid-cols-2 gap-10 items-start">
//           {/* Contact Info */}
//           <div>
//             <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//               Let’s Start a Conversation
//             </h2>
//             <p className="text-gray-600 mb-6">
//               Whether you’re looking for technical support, partnership opportunities,
//               or just want to say hello — we’d love to hear from you.
//             </p>
//             <div className="space-y-4 text-gray-700">
//               <p>📞 <span className="font-semibold">Phone:</span> +92 321 4994888</p>
//               <p>📧 <span className="font-semibold">Email:</span> info@synergysoft.com.pk</p>
//               <p>📍 <span className="font-semibold">Address:</span> Lahore, Pakistan</p>
//             </div>
//           </div>

//           {/* Contact Form */}
//           <form
//             onSubmit={handleSubmit}
//             className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200"
//           >
//             <div className="grid md:grid-cols-2 gap-6 mb-6">
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Full Name"
//                 required
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
//               />
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 placeholder="Email Address"
//                 required
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
//               />
//             </div>

//             <input
//               type="tel"
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               placeholder="Phone Number"
//               className="w-full mb-6 px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
//             />

//             <textarea
//               name="message"
//               value={formData.message}
//               onChange={handleChange}
//               placeholder="Your Message Or Query"
//               rows="5"
//               required
//               className="w-full mb-6 px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
//             ></textarea>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold py-3 rounded-lg hover:opacity-90 transition-all"
//             >
//               {loading ? "Sending..." : "Send Message"}
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Success Popup */}
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-8 rounded-2xl shadow-lg text-center animate-fadeIn">
//             <h3 className="text-2xl font-semibold text-blue-600 mb-2">
//               ✅ Message Sent!
//             </h3>
//             <p className="text-gray-600">
//               Our team will contact you soon. Thank you for reaching out!
//             </p>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }
import React, { useState } from "react";
import { supabase } from "../lib/supabaseclient";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase.from("contact_requests").insert([
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      },
    ]);

    setLoading(false);

    if (error) {
      console.error("❌ Error submitting form:", error.message);
      alert("Something went wrong. Please try again.");
    } else {
      console.log("✅ Form submitted successfully!");
      setShowPopup(true);
      setFormData({ name: "", email: "", phone: "", message: "" });
      setTimeout(() => setShowPopup(false), 3000);
    }
  };

  return (
    <main className="w-full bg-white text-gray-800">
      {/* 🔹 Banner Section */}
      <section className="w-full relative bg-[linear-gradient(160deg,#1e40af_0%,#0891b2_100%)] text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4">
            Contact <span className="text-cyan-300">Us</span>
          </h1>
          <p className="text-blue-100 max-w-2xl mx-auto text-lg">
            We’d love to hear from you! Get in touch with our team for support,
            inquiries, or partnership opportunities.
          </p>
        </div>
      </section>

      {/* 🔹 Contact Section */}
      <section className="w-full bg-[#f8faff] py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-3">
              Get in Touch
            </h2>
            <p className="text-gray-600 text-lg">
              Have questions or need help? We’re here for you 24/7.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Contact Info */}
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                Let’s Start a Conversation
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Whether you’re looking for technical support, partnership
                opportunities, or just want to say hello — we’d love to hear
                from you.
              </p>
              <div className="space-y-4 text-gray-700">
                <p>
                  📞 <span className="font-semibold">Phone:</span> +92 321 4994888
                </p>
                <p>
                  📧 <span className="font-semibold">Email:</span>{" "}
                  info@synergysoft.com.pk
                </p>
                <p>
                  📍 <span className="font-semibold">Address:</span> Lahore,
                  Pakistan
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <form
              onSubmit={handleSubmit}
              className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 w-full"
            >
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full Name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                className="w-full mb-6 px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message or Query"
                rows="5"
                required
                className="w-full mb-6 px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold py-3 rounded-lg hover:opacity-90 transition-all"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* 🔹 Success Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-2xl shadow-lg text-center animate-fadeIn">
            <h3 className="text-2xl font-semibold text-blue-600 mb-2">
              ✅ Message Sent!
            </h3>
            <p className="text-gray-600">
              Our team will contact you soon. Thank you for reaching out!
            </p>
          </div>
        </div>
      )}
    </main>
  );
}
